module.exports = __webpack_public_path__ + "static/img/template_img_01.94759b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/template_img_01.jpg
// module id = 393
// module chunks = 0